import { render, staticRenderFns } from "./FeaturedBook.vue?vue&type=template&id=5b36f9c8&scoped=true&"
import script from "./FeaturedBook.vue?vue&type=script&lang=js&"
export * from "./FeaturedBook.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedBook.vue?vue&type=style&index=0&id=5b36f9c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b36f9c8",
  null
  
)

export default component.exports